import { useEffect, useState } from '@wordpress/element';
import Card from '../../componentsNew/Card';
import StepIcon from '../../componentsNew/StepIcon';
import Button from '../../componentsNew/Button';
import Typography from '../../componentsNew/Typography';
import { StepContexto } from './Steps/StepContexto';
import { StepPalavraChave } from './Steps/StepPalavraChave';
import { StepReferencia } from './Steps/StepReferencia';
import { StepEstruturaTexto } from './Steps/StepEstruturaTexto';
import { GerarConteudoImagem } from '../../api/controllers/optiGenerator';
import CircularProgress from '../../componentsNew/CircularProgress';
import { toast } from 'react-toastify';
import { useIntegracao } from './Context/IntegracaoContext';
import { CustomWarning } from '@componentsNew/CustomWarning';
import { alert } from '@componentsNew/CustomWarning/types';

export function CardStep({ step, setStep, setConteudo, connectionId, setarLoading }) {
  const [form, setForm] = useState({
    tema: '',
    descricao: '',
    persona: '0',
    objetivo: 'Tempo de Engajamento',
    palavraChave: '',
    intencaoPalavraChave: 'Informativa',
    tamanhoTexto: 'SMALL',
    linksReferencia: [],
    custoArtigoIaId: 0,
    stream_Id: '',
  });

  const [loading, setLoading] = useState(false);
  const [errorIa, setErrorIA] = useState(false);

  const [errorBlockNext, setErrorBlockNext] = useState(false);

  //const [custoId, setCustoId] = useState(0);

  const { setPalavrasChave, setMetadescricao, setHtml } = useIntegracao();

  const mudarValor = (prop, value) => {
    setForm({ ...form, [prop]: value });
    if (prop === 'palavraChave') {
      setPalavrasChave(value);
    }
  };

  useEffect(() => {
    mudarValor('stream_Id', connectionId);
  }, [connectionId]);

  useEffect(() => {
    if (setarLoading) {
      setLoading(false);
    }
  }, [setarLoading]);

  const mudarStep = avancar => {
    if (step == 1) {
      if (!form.tema || form.tema.trim() == '') {
        toast.error('Digite o tema do texto!', {
          toastId: 'error_tema',
        });

        return;
      }

      if (!form.descricao || form.descricao.trim() == '') {
        toast.error('Descreva o texto do artigo!', {
          toastId: 'error_descricao',
        });

        return;
      }
    }

    if (step == 2) {
      if (!form.palavraChave || form.palavraChave.trim() == '') {
        toast.error('Informe a palavra-chave!', {
          toastId: 'error_palavraChave',
        });

        return;
      }
    }

    setStep(avancar ? step + 1 : step - 1);
  };

  const gerarArtigo = () => {
    setLoading(true);
    localStorage.setItem('id_artigo_ia', 0);

    GerarConteudoImagem(form)
      .then(({ data }) => {
        setHtml(data?.conteudo?.html);
        setMetadescricao(data?.conteudo?.meta_description);
        setConteudo(data);
        setLoading(false);
        setStep(5);
      })
      .catch(() => {
        setErrorIA(true);
      });
  };

  const mensagensDeCarregamento = [
    'Estamos gerando o seu conteudo.',
    'Explorando suas inspirações para criar algo novo.',
    'Estamos analisando suas referências.',
    'Estamos criando sua imagem.',
    'Estamos otimizando seu artigo.',
    'Ajustando os detalhes do seu artigo.',
    'Estruturando seu conteúdo para o melhor impacto.',
  ];

  const [indexDeMensagem, setIndexDeMensagem] = useState(0);

  useEffect(() => {
    if (!loading) return;
    const intervalId = setInterval(() => {
      setIndexDeMensagem(indexAnterior =>
        indexAnterior === mensagensDeCarregamento.length - 1 ? 0 : indexAnterior + 1
      );
    }, 15000);

    return () => clearInterval(intervalId);
  }, [loading]);

  return (
    <Card className="p-8 w-3/6">
      {errorIa && (
        <CustomWarning
          alertType={alert.error}
          content={
            <Typography className="font-[0.75rem] mt-4">
              Houve um erro inesperado ao tentar gerar o artigo, tente novamente mais tarde.
            </Typography>
          }
        />
      )}

      {loading && !errorIa && (
        <>
          <div className="flex flex-col items-center">
            <CircularProgress className="mt-8" />
            <p className="text-center mt-4">{mensagensDeCarregamento[indexDeMensagem]}</p>
          </div>
        </>
      )}

      {!loading && (
        <>
          {step != 5 && <StepIcon step={step} />}
          {step <= 1 && <StepContexto form={form} mudarValor={mudarValor} />}
          {step == 2 && <StepPalavraChave setErroNext={setErrorBlockNext} form={form} mudarValor={mudarValor} />}
          {step == 3 && (
            <StepReferencia 
              setErroNext={setErrorBlockNext}
              tema={form.tema}
              descricao={form.descricao}
              keyword={form.palavraChave}
              form={form}
              mudarValor={mudarValor}
            />
          )}
          {step == 4 && <StepEstruturaTexto form={form} mudarValor={mudarValor} />}

          {step != 5 ? (
            <div className="flex justify-between mt-8">
              <Button
                component="outlined"
                className="w-[45%]"
                onClick={() => {
                  mudarStep();
                }}
              >
                <Typography component="button">
                  {step == 1 && <>Cancelar</>} {step != 1 && <>Voltar</>}{' '}
                </Typography>
              </Button>
              {step != 4 && (
                <Button
                  className="w-[45%]"
                  disabled={errorBlockNext}
                  onClick={() => {
                    mudarStep(true);
                  }}
                >
                  <Typography component="button">Avançar</Typography>
                </Button>
              )}

              {step == 4 && (
                <Button
                  className="w-[45%]"
                  onClick={() => {
                    gerarArtigo();
                  }}
                >
                  <Typography component="button"> Gerar artigo</Typography>
                </Button>
              )}
            </div>
          ) : (
            <Button
              component="outlined"
              className="mt-6 w-full"
              onClick={() => {
                mudarStep();
              }}
            >
              <Typography component="button">Voltar</Typography>
            </Button>
          )}
        </>
      )}
    </Card>
  );
}
